import React from 'react';

import { useStyles } from './style';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { PaymentMethod } from '../../../../../api/payment-method/types';
import { Elements } from '@stripe/react-stripe-js';
import { PaymentCards } from '../../PaymentCards';
import { loadStripe } from '@stripe/stripe-js';

interface Props {
  paymentItem?: PaymentMethod;
  backStep: () => void;
}

export const PaymentForm: React.FC<Props> = ({ backStep }) => {
  const classes = useStyles();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISABLE_KEY as string, { apiVersion: '2023-08-16' });

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box>
          <Typography className={classes.cardFeatureTitle}>
            New Payment Method
          </Typography>
          <Box>
            <Elements stripe={stripePromise} >
              <PaymentCards
                isCreatePayment={true}
                buttonText='Add Payment Method'
                completeCreatePayment={backStep}
              />
            </Elements>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
